import { createAction, props } from '@ngrx/store'
import { ReviewModel, RequestModel, ReviewPageRequestDescriptor } from '@models/index'
import { ReviewPerReviewSiteModel } from '@models/reviewPerReviewSitePerLocation.model'

export const searchReviewsByLocation = createAction(
    '[Reviews Page] Search Reviews By Location',
    props<{ request: RequestModel }>()
)

export const searchReviewsByLocationId = createAction(
    '[Reviews Page] Search Reviews By Location Id',
    props<{ request: RequestModel }>()
)

export const getTotalReviewsByLocation = createAction(
    '[Reviews Page] Geto Total Reviews By Location',
    props<{ request: RequestModel }>()
)

export const getTotalReviewsByLocationSuccess = createAction(
    '[Reviews Page] Geto Total Reviews By Location Success',
    props<{ total: number }>()
)

export const filterReviewsByLocation = createAction(
    '[Reviews Page] Filter Reviews By Location',
    props<{ request: RequestModel }>()
)

export const getPagesId = createAction(
    '[Reviews Page] Get Pages Id',
    props<{ request: RequestModel }>()
)

export const getPagesIdSuccess = createAction(
    '[Reviews Page] Get Pages Id Success',
    props<{ data: ReviewPageRequestDescriptor[] }>()
)

export const filterReviewsByLocationId = createAction(
    '[Reviews Page] Filter Reviews By Location Id',
    props<{ request: RequestModel }>()
)

export const getAllReviews = createAction(
    '[Reviews Page] Get All Reviews',
    props<{ request: RequestModel }>()
)

export const searchReviewsSuccess = createAction(
    '[Reviews Page] Search Reviews Success',
    props<{ total: number, data: ReviewModel[] }>()
)

export const replyToReview = createAction(
    '[Reviews Page] Reply To Review',
    props<{ request: RequestModel }>()
)

export const replyToReviewSuccess = createAction(
    '[Reviews Page] Reply To Review Success',
    props<{ data: ReviewModel }>()
)


export const deleteReviewReply = createAction(
    '[Reviews Page] Delete Review Reply',
    props<{ request: RequestModel }>()
)

export const deleteReviewReplySuccess = createAction(
    '[Reviews Page] Delete Review Reply Success',
    props<{ data:  ReviewModel}>()
)

export const reviewError = createAction(
    '[Reviews Page] Review Error',    
    props<{ error: string }>()
)

export const generateReplyResponse = createAction(
    '[Reviews Reply] Generate Reply Response',
    props<{ request: RequestModel }>()
)

export const generateReplyResponseSuccess = createAction(
    '[Reviews Reply] Generate Reply Response Success',
    props<{ data: any }>()
)

export const replyIntegration = createAction(
    '[Review Page] Reply Integration',
    props<{ request: RequestModel }>()
)

export const replyIntegrationSuccess = createAction(
    '[Review Page] Reply Integrion Success',
    props<{data: ReviewModel}>()
)
export const markReviewSpam = createAction(
    '[Reviews Page] Mark Review as Spam',
    props<{request: RequestModel}>()
)

export const markReviewSpamSuccess = createAction(
    '[Reviews Page] Mark Review as Spam Success',
    props<{data: ReviewModel}>()
)
